/* eslint-disable no-restricted-syntax,no-prototype-builtins */
import api from '../../utils/apiFetch';

const path = 'loyalties';

const serialize = (obj) => {
  const str = [];
  for (const p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
    }
  return str.join('&');
};

export default {
  getNewLoyaltyProgram: () => api.get(`${path}/program`),
  getLoyaltyDetails: (id) => api.get(`${path}/${id}`),
  saveLoyaltyProgram: (payload) =>
    api.put(`${path}/program/${payload.id}`, payload),
  getProgramList: (params) => api.get(`${path}/programs?${serialize(params)}`),
  getOverarchingProgramList: (params) =>
    api.get(`${path}/overarching-programs?${serialize(params)}`),
  postOverarchingProgram: (payload) =>
    api.post(`${path}/overarching-programs`, payload),
  getLoyaltyList: (params) => api.get(`${path}?${serialize(params)}`),
  addLoyaltyPoint: (payload) => api.post(`${path}/add-points`, payload),
  uploadLoyaltyCSV: (params) => api.file(`${path}/import`, params),
  getItems: (params) => api.get(`${path}/items?${serialize(params)}`),
  getItemsByCategory: (categories) =>
    api.post(`${path}/items`, {
      category_ids:
        categories === undefined
          ? undefined
          : Array.isArray(categories)
          ? categories
          : [categories],
    }),
  getLoyaltyTransactions: (params) =>
    api.get(`${path}/loyalty-transactions?${serialize(params)}`),
  getSecondaryLoyaltyTransactions: (params) =>
    api.get(
      `${path}/merchant-secondary-loyalty-transactions?${serialize(params)}`
    ),
  resendEmail: (id) => api.get(`${path}/resend/${id}`),
  sendReferralEmail: (id) => api.get(`${path}/send-referral/${id}`),
  getLoyalty: (payload) =>
    api.get(`${path}/referred-customers?${serialize(payload)}`),
  sendWhatsApp: (id) => api.get(`${path}/whatsApps/${id}`),
  getLoyaltyProgramApi: (params) =>
    api.get(`${path}/customers-by-program?${serialize(params)}`),
  sendCustomEmailApi: (payload) =>
    api.post(`${path}/send-custom-email`, payload),
  enableOverarchingProgram: (enabled) =>
    api.post(
      `${path}/enable-overarching-program?enabled=${enabled.toString()}`
    ),
  getTopCustomerEarnPointt: (payload) =>
    api.post(`${path}/statistic-earn-point`, payload),
  getReferredCustomers: (payload) =>
    api.post(`${path}/referred-customers-statistics`, payload),
  getSpendStats: (params) =>
    api.get(`${path}/spend-stats?${serialize(params)}`),
  getSpendList: (params) => api.get(`${path}/spend-list?${serialize(params)}`),
  getBusinessSpendList: (params) =>
    api.get(`${path}/business-spend-list?${serialize(params)}`),
  getLocationSpendList: (params) =>
    api.get(`${path}/location-spend-list?${serialize(params)}`),
  changeLoyaltyProgramApi: (payload) =>
    api.post(`${path}/change-loyalty-program`, payload),
  sendReferralProgramEmail: (payload) =>
    api.post(`${path}/send-referral-program`, payload),
  updateLoyaltyCustomer: (payload) => api.put(`${path}/customer`, payload),
};
